import { Calendar } from "lucide-react";
import { useState } from "react";
import { Popover } from "@mui/material";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const WDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function ScheduleNACHModal({
  rowData,
  anchorEl,
  open,
  onClose,
}) {
  const today = new Date();
  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());
  const [selected, setSelected] = useState(null);

  const shiftMonth = (dir) => {
    setSelected(null);
    if (month + dir > 11) {
      setMonth(0);
      setYear((y) => y + 1);
    } else if (month + dir < 0) {
      setMonth(11);
      setYear((y) => y - 1);
    } else setMonth((m) => m + dir);
  };

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const prevDays = new Date(year, month, 0).getDate();

  const handleDone = () => {
    if (!selected) return;
    console.log(
      `Scheduled NACH for ${rowData?.loanId} on ${MONTHS[month]} ${selected}, ${year}`,
    );
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.14)",
          mt: 1,
        },
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          width: 260,
          padding: 18,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 14,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
            <span
              style={{
                width: 30,
                height: 30,
                borderRadius: 8,
                background: "#FFFBEB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#F59E0B",
              }}
            >
              <Calendar size={15} />
            </span>
            <span style={{ fontSize: 13.5, fontWeight: 600, color: "#111827" }}>
              Schedule NACH
            </span>
          </div>
          <button
            onClick={handleDone}
            style={{
              background: "#035865",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "7px 18px",
              fontSize: 13,
              cursor: "pointer",
              fontWeight: 500,
            }}
          >
            Done
          </button>
        </div>

        {/* Month Nav */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 12,
          }}
        >
          <button onClick={() => shiftMonth(-1)} style={navBtn}>
            ‹
          </button>
          <span style={{ fontSize: 13.5, fontWeight: 600, color: "#035865" }}>
            {MONTHS[month]} {year}
          </span>
          <button onClick={() => shiftMonth(1)} style={navBtn}>
            ›
          </button>
        </div>

        {/* Day headers */}
        <div style={grid}>
          {WDAYS.map((d) => (
            <div
              key={d}
              style={{
                fontSize: 11,
                color: "#9ca3af",
                textAlign: "center",
                padding: "4px 0",
                fontWeight: 500,
              }}
            >
              {d}
            </div>
          ))}
        </div>

        {/* Days */}
        <div style={grid}>
          {Array.from({ length: firstDay }, (_, i) => (
            <div
              key={`p${i}`}
              style={{ ...dayBase, color: "#d1d5db", cursor: "default" }}
            >
              {String(prevDays - firstDay + 1 + i).padStart(2, "0")}
            </div>
          ))}
          {Array.from({ length: daysInMonth }, (_, i) => {
            const d = i + 1;
            const isToday =
              d === today.getDate() &&
              month === today.getMonth() &&
              year === today.getFullYear();
            const isSel = d === selected;
            return (
              <button
                key={d}
                onClick={() => setSelected(d)}
                style={{
                  ...dayBase,
                  cursor: "pointer",
                  background: isSel ? "#035865" : "none",
                  color: isSel ? "#fff" : isToday ? "#035865" : "#374151",
                  fontWeight: isSel || isToday ? 600 : 400,
                  border: isToday && !isSel ? "1.5px solid #035865" : "none",
                }}
              >
                {String(d).padStart(2, "0")}
              </button>
            );
          })}
          {Array.from(
            { length: (7 - ((firstDay + daysInMonth) % 7)) % 7 },
            (_, i) => (
              <div
                key={`n${i}`}
                style={{ ...dayBase, color: "#d1d5db", cursor: "default" }}
              >
                {String(i + 1).padStart(2, "0")}
              </div>
            ),
          )}
        </div>

        {selected && (
          <div
            style={{
              fontSize: 12,
              color: "#6b7280",
              textAlign: "center",
              marginTop: 10,
            }}
          >
            Selected: {MONTHS[month]} {selected}, {year}
          </div>
        )}
      </div>
    </Popover>
  );
}

const navBtn = {
  width: 28,
  height: 28,
  borderRadius: "50%",
  border: "1px solid #e5e7eb",
  background: "#fff",
  cursor: "pointer",
  fontSize: 16,
  color: "#6b7280",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const grid = { display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 3 };
const dayBase = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  aspectRatio: "1",
  fontSize: 12.5,
  borderRadius: "50%",
  fontFamily: "inherit",
  border: "none",
};
